// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3SN3K"};